import React from 'react';

const Graph_D3_js = () => {
    return (
        <div>Graph_D3_js Component</div>
    );
}

export default Graph_D3_js;
